import { useEffect } from 'react';

import { useUserPrint } from '@app/hooks/useUserPrint';
import { createWSConnection, logOutUser, subscribeToWsEvent } from '@app/utils';
import { invokeWSMethod } from '@app/utils/createWSConnection';

export const useUserDelete = () => {
  const { userId, database } = useUserPrint();

  useEffect(() => {
    if (userId && database) {
      createWSConnection(async () => {
        await invokeWSMethod('ListenUser', database, userId);

        subscribeToWsEvent('OnUserDelete', logOutUser);
      });
    }
  }, [database, userId]);
};
